import React from 'react';
import {
  Dashboard as DashboardIcon,
  CorporateFare as CorporateFareIcon,
  PeopleRounded as PeopleRoundedIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Handshake as HandshakeIcon,
  Support as SupportIcon,
  History as HistoryIcon,
  Language as LanguageIcon,
  MonitorHeart as MonitorHeartIcon,
  Microsoft as MicrosoftIcon,
  Storage as StorageIcon,
  Draw as DrawIcon,
  Shield as ShieldIcon,
  Key as KeyIcon,
  Person as PersonIcon,
  Computer as ComputerIcon,
  GridOn as GridOnIcon,
  Newspaper as NewspaperIcon,
  FileUpload as FileUploadIcon,
  Inventory as InventoryIcon,
  Timeline,
  DirectionsCar,
  SettingsRounded as SettingsRoundedIcon,
  HomeRounded as HomeRoundedIcon,
} from '@mui/icons-material';

export const MENU_ICON_OPTIONS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'home', label: 'Accueil' },
  { key: 'clients', label: 'Clients' },
  { key: 'users', label: 'Utilisateurs' },
  { key: 'document', label: 'Document' },
  { key: 'contract', label: 'Contrat' },
  { key: 'support', label: 'Support' },
  { key: 'history', label: 'Historique' },
  { key: 'domain', label: 'Domaine' },
  { key: 'monitoring', label: 'Monitoring' },
  { key: 'microsoft', label: 'Microsoft' },
  { key: 'storage', label: 'Stockage' },
  { key: 'signitic', label: 'Signitic' },
  { key: 'security', label: 'Sécurité' },
  { key: 'key', label: 'Clé' },
  { key: 'person', label: 'Personne' },
  { key: 'computer', label: 'Ordinateur' },
  { key: 'matrix', label: 'Matrice' },
  { key: 'news', label: 'Actualité' },
  { key: 'import', label: 'Import' },
  { key: 'products', label: 'Produits' },
  { key: 'timeline', label: 'Temps' },
  { key: 'car', label: 'Déplacements' },
  { key: 'settings', label: 'Paramètres' },
];

const iconMap = {
  dashboard: DashboardIcon,
  home: HomeRoundedIcon,
  clients: CorporateFareIcon,
  users: PeopleRoundedIcon,
  document: InsertDriveFileIcon,
  contract: HandshakeIcon,
  support: SupportIcon,
  history: HistoryIcon,
  domain: LanguageIcon,
  monitoring: MonitorHeartIcon,
  microsoft: MicrosoftIcon,
  storage: StorageIcon,
  signitic: DrawIcon,
  security: ShieldIcon,
  key: KeyIcon,
  person: PersonIcon,
  computer: ComputerIcon,
  matrix: GridOnIcon,
  news: NewspaperIcon,
  import: FileUploadIcon,
  products: InventoryIcon,
  timeline: Timeline,
  car: DirectionsCar,
  settings: SettingsRoundedIcon,
};

export function getMenuIcon(iconKey) {
  const Icon = iconMap[iconKey] || DashboardIcon;
  return <Icon />;
}

export const DEFAULT_MENU_SECTIONS = [
  { key: 'operations', label: 'Opérations', icon: 'timeline', order: 1, visible: true },
  { key: 'infrastructure', label: 'Infrastructure', icon: 'computer', order: 2, visible: true },
  { key: 'admin', label: 'Admin', icon: 'settings', order: 3, visible: true },
];

export const DEFAULT_MENU_ITEMS = [
  { key: 'home', text: 'Home', icon: 'dashboard', value: 'dashboard/home', permission: 'view.home', order: 0, visible: true },
  { key: 'clients', text: 'Clients', icon: 'clients', value: 'dashboard/organizations', permission: 'view.organizations', sectionKey: 'operations', order: 1, visible: true, subItems: [
    { key: 'clients.list', text: 'Liste des clients', value: '', icon: 'clients', permission: 'view.organizations', order: 1, visible: true },
    { key: 'clients.portfolio', text: 'Portfeuille', value: 'portfolio', icon: 'clients', permission: 'view.organizations.portfolio', order: 2, visible: true },
    { key: 'clients.users', text: 'Liste des utilisateurs', value: 'users', icon: 'users', permission: 'view.organizations.users', order: 3, visible: true },
  ]},
  { key: 'quotes', text: 'Devis', icon: 'document', value: 'dashboard/quotes', permission: 'view.quotes', sectionKey: 'operations', order: 2, visible: true, subItems: [
    { key: 'quotes.list', text: 'Liste des devis', value: '', icon: 'dashboard', order: 1, visible: true },
    { key: 'quotes.sign', text: 'Signer le devis', value: 'form', icon: 'document', order: 2, visible: true },
  ]},
  { key: 'contracts', text: 'Contrats', icon: 'contract', value: 'dashboard/contrats', permission: 'view.contracts', sectionKey: 'operations', order: 3, visible: true, subItems: [
    { key: 'contracts.dashboard', text: 'Dashboard', value: '', icon: 'dashboard', permission: 'view.contracts', order: 1, visible: true },
    { key: 'contracts.annual', text: 'Annuel', value: 'annual', icon: 'dashboard', permission: 'view.contracts.annual', order: 2, visible: true },
    { key: 'contracts.monthly', text: 'Mensuel', value: 'monthly', icon: 'dashboard', permission: 'view.contracts.monthly', order: 3, visible: true },
    { key: 'contracts.list', text: 'Liste des contrats', value: 'list', icon: 'dashboard', permission: 'view.contracts.list', order: 4, visible: true },
    { key: 'contracts.matrix', text: 'Matrice de compétences', value: 'matrix', icon: 'matrix', permission: 'view.contracts.matrix', order: 5, visible: true },
  ]},
  { key: 'tickets', text: 'Ticketing', icon: 'support', value: 'dashboard/tickets', permission: 'view.tickets', sectionKey: 'operations', order: 4, visible: true, subItems: [
    { key: 'tickets.list', text: 'Tickets', value: '', icon: 'support', permission: 'view.tickets', order: 1, visible: true },
    { key: 'tickets.time', text: 'Temps passés', value: 'timeEntry', icon: 'timeline', permission: 'view.tickets.time', order: 2, visible: true },
    { key: 'tickets.ik', text: 'IK', value: 'ik', icon: 'car', permission: 'view.tickets.ik', order: 3, visible: true },
    { key: 'tickets.myik', text: 'Mes IK', value: 'myik', icon: 'car', permission: 'view.tickets.myik', order: 4, visible: true },
  ]},
  { key: 'history', text: 'Historique', icon: 'history', value: 'dashboard/history', permission: 'view.history', sectionKey: 'operations', order: 5, visible: true },
  { key: 'domain', text: 'Nom de domaine', icon: 'domain', value: 'dashboard/domain', permission: 'view.domains', sectionKey: 'infrastructure', order: 1, visible: true },
  { key: 'centreon', text: 'Centreon', icon: 'monitoring', value: 'dashboard/centreon', permission: 'view.centreon', sectionKey: 'infrastructure', order: 2, visible: true },
  { key: 'level', text: 'Level', icon: 'computer', value: 'dashboard/level', permission: 'view.level', sectionKey: 'infrastructure', order: 3, visible: true, subItems: [
    { key: 'level.devices', text: 'Devices', value: 'devices', icon: 'computer', permission: 'view.level.devices', order: 1, visible: true },
  ]},
  { key: 'o365', text: 'O365', icon: 'microsoft', value: 'dashboard/o365', permission: 'view.o365', sectionKey: 'infrastructure', order: 4, visible: true, subItems: [
    { key: 'o365.general', text: 'Général', value: '', icon: 'dashboard', permission: 'view.o365', order: 1, visible: true },
    { key: 'o365.licenses', text: 'Licenses', value: 'licenses', icon: 'key', permission: 'view.o365.licenses', order: 2, visible: true },
    { key: 'o365.users', text: 'Utilisateurs', value: 'users', icon: 'person', permission: 'view.o365.users', order: 3, visible: true },
  ]},
  { key: 'vbo365', text: 'Veeam Backup O365', icon: 'storage', value: 'dashboard/vbo365', permission: 'view.vbo365', sectionKey: 'infrastructure', order: 5, visible: true, subItems: [
    { key: 'vbo365.general', text: 'Général', value: '', icon: 'dashboard', permission: 'view.vbo365', order: 1, visible: true },
    { key: 'vbo365.licenses', text: 'Licenses', value: 'licenses', icon: 'key', permission: 'view.vbo365.licenses', order: 2, visible: true },
    { key: 'vbo365.users', text: 'Utilisateurs', value: 'users', icon: 'person', permission: 'view.vbo365.users', order: 3, visible: true },
  ]},
  { key: 'eset', text: 'ESET', icon: 'security', value: 'dashboard/eset', permission: 'view.eset', sectionKey: 'infrastructure', order: 6, visible: true, subItems: [
    { key: 'eset.general', text: 'Général', value: '', icon: 'dashboard', permission: 'view.eset', order: 1, visible: true },
    { key: 'eset.licenses', text: 'Licenses', value: 'licenses', icon: 'key', permission: 'view.eset.licenses', order: 2, visible: true },
    { key: 'eset.devices', text: 'Appareils', value: 'devices', icon: 'computer', permission: 'view.eset.devices', order: 3, visible: true },
  ]},
  { key: 'signitic', text: 'Signitic', icon: 'signitic', value: 'dashboard/signitic', permission: 'view.signitic', sectionKey: 'infrastructure', order: 7, visible: true, subItems: [
    { key: 'signitic.general', text: 'Général', value: '', icon: 'dashboard', order: 1, visible: true },
  ]},
  { key: 'newsletter', text: 'Newsletter', icon: 'news', value: 'dashboard/sarbacane', sectionKey: 'infrastructure', order: 8, visible: true, subItems: [
    { key: 'newsletter.lists', text: 'Listes', value: '', icon: 'dashboard', order: 1, visible: true },
  ]},
  { key: 'mc3cloud', text: 'MC3 Cloud', icon: 'microsoft', value: 'dashboard/mc3cloud', permission: 'view.mc3.products', sectionKey: 'infrastructure', order: 9, visible: true, subItems: [
    { key: 'mc3cloud.products', text: 'Produits', value: 'products', icon: 'products', permission: 'view.mc3.products', order: 1, visible: true },
  ]},
  { key: 'import', text: 'Imports', icon: 'import', value: 'dashboard/import', permission: 'view.import', sectionKey: 'infrastructure', order: 10, visible: true, subItems: [
    { key: 'import.meg', text: 'MEG vers Pipedrive', value: '', icon: 'import', order: 1, visible: true },
  ]},
  { key: 'settings', text: 'Paramètres', icon: 'settings', value: 'dashboard/settings', permission: 'view.settings', sectionKey: 'admin', order: 1, visible: true, subItems: [
    { key: 'settings.general', text: 'Général', value: 'general', icon: 'settings', permission: 'view.settings', order: 1, visible: true },
    { key: 'settings.permissions', text: 'Permissions', value: 'permissions', icon: 'settings', permission: 'view.permissions', order: 2, visible: true },
    { key: 'settings.signitic', text: 'Signitic', value: 'signitic', icon: 'signitic', permission: 'view.settings', order: 3, visible: true },
    { key: 'settings.eset', text: 'ESET', value: 'eset', icon: 'security', permission: 'view.settings', order: 4, visible: true },
    { key: 'settings.level', text: 'Level.io', value: 'level', icon: 'computer', permission: 'view.settings', order: 5, visible: true },
    { key: 'settings.cron', text: 'Cron', value: 'cron', icon: 'settings', permission: 'view.settings', order: 6, visible: true },
  ]},
  { key: 'products', text: 'Produits', icon: 'products', value: 'dashboard/products', permission: 'view.products', sectionKey: 'admin', order: 2, visible: true },
  { key: 'reports', text: 'Rapports', icon: 'products', value: 'dashboard/reports', permission: 'view.reports', sectionKey: 'admin', order: 3, visible: true },
  { key: 'invoices', text: 'Factures', icon: 'products', value: 'dashboard/factures', permission: 'view.invoices', sectionKey: 'admin', order: 4, visible: true },
];

function normalizeList(list) {
  return Array.isArray(list) ? list : [];
}

function mapByKey(list) {
  return normalizeList(list).reduce((acc, item) => {
    if (item?.key) acc[item.key] = item;
    return acc;
  }, {});
}

function sortByOrder(a, b) {
  return Number(a.order ?? 999) - Number(b.order ?? 999) || String(a.text || a.label || '').localeCompare(String(b.text || b.label || ''), 'fr');
}

function applyItemOverride(item, overrides, inheritedSectionKey = null, parentKey = null) {
  const override = overrides[item.key] || {};
  const visible = override.visible ?? item.visible ?? true;
  if (!visible) return null;

  const next = {
    ...item,
    parentKey,
    text: override.text || item.text,
    icon: override.icon || item.icon,
    sectionKey: parentKey ? inheritedSectionKey : (override.sectionKey || item.sectionKey || inheritedSectionKey),
    order: override.order ?? item.order,
    visible,
  };

  if (Array.isArray(item.subItems)) {
    next.subItems = item.subItems
      .map((subItem) => applyItemOverride(subItem, overrides, next.sectionKey, item.key))
      .filter(Boolean)
      .sort(sortByOrder);
  }

  return next;
}

function mergeSections(config = {}) {
  const sectionOverrides = mapByKey(config?.sections);
  const defaultKeys = new Set(DEFAULT_MENU_SECTIONS.map((section) => section.key));
  const defaults = DEFAULT_MENU_SECTIONS.map((section) => {
    const override = sectionOverrides[section.key] || {};
    return {
      ...section,
      label: override.label || section.label,
      icon: override.icon || section.icon,
      order: override.order ?? section.order,
      visible: override.visible ?? section.visible ?? true,
      custom: false,
    };
  });
  const custom = normalizeList(config?.sections)
    .filter((section) => section?.key && !defaultKeys.has(section.key))
    .map((section) => ({
      key: section.key,
      label: section.label || section.key,
      icon: section.icon || 'settings',
      order: section.order ?? 99,
      visible: section.visible ?? true,
      custom: true,
    }));

  return [...defaults, ...custom];
}

export function buildMenuFromSettings(config = {}) {
  const itemOverrides = mapByKey(config?.items);
  const sections = mergeSections(config)
    .filter((section) => section.visible)
    .sort(sortByOrder);

  const items = DEFAULT_MENU_ITEMS
    .map((item) => applyItemOverride(item, itemOverrides))
    .filter(Boolean);

  const withoutSection = items
    .filter((item) => !item.sectionKey)
    .sort(sortByOrder);

  const result = [...withoutSection];
  sections.forEach((section) => {
    const sectionItems = items
      .filter((item) => item.sectionKey === section.key)
      .sort(sortByOrder);
    if (sectionItems.length) {
      result.push({ section: section.label, key: section.key, icon: section.icon });
      result.push(...sectionItems);
    }
  });

  return result;
}

export function flattenEditableMenuItems(config = {}) {
  const itemOverrides = mapByKey(config?.items);
  const rows = [];

  DEFAULT_MENU_ITEMS.forEach((item) => {
    const override = itemOverrides[item.key] || {};
    rows.push({
      key: item.key,
      text: override.text || item.text,
      icon: override.icon || item.icon,
      sectionKey: override.sectionKey || item.sectionKey || '',
      order: override.order ?? item.order,
      visible: override.visible ?? item.visible ?? true,
      parentKey: '',
      type: 'menu',
    });
    (item.subItems || []).forEach((subItem) => {
      const subOverride = itemOverrides[subItem.key] || {};
      rows.push({
        key: subItem.key,
        text: subOverride.text || subItem.text,
        icon: subOverride.icon || subItem.icon,
        sectionKey: item.sectionKey || '',
        order: subOverride.order ?? subItem.order,
        visible: subOverride.visible ?? subItem.visible ?? true,
        parentKey: item.key,
        parentText: item.text,
        type: 'sous-menu',
      });
    });
  });

  return rows;
}

export function editableSections(config = {}) {
  return mergeSections(config).map((section) => ({
    key: section.key,
    label: section.label,
    icon: section.icon,
    order: section.order,
    visible: section.visible,
    custom: Boolean(section.custom),
  }));
}
